// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qS7F","signatureBlock":"Footer_signatureBlock__3y7xq","signature":"Footer_signature__1A2p3"};